import type { PromotionalCardTitle } from '@eneco/sparky';

const MAX_TITLE_LINES = 4;

/** Maps CMS title lines to a PromotionalCard title (2–4 non-empty lines). */
export const toPromotionalCardTitle = (lines: Array<string | undefined>): PromotionalCardTitle | undefined => {
  const trimmed = lines
    .map(line => line?.trim() ?? '')
    .filter(Boolean)
    .slice(0, MAX_TITLE_LINES);

  const [first, second, third, fourth] = trimmed;

  if (first && second && third && fourth) {
    return [first, second, third, fourth];
  }

  if (first && second && third) {
    return [first, second, third];
  }

  if (first && second) {
    return [first, second];
  }

  return undefined;
};
